import router from "../../router";
import Segments from "../../apis/Segments";

var objKey = "";

const state = {
  keys: [],
  audienceRecords: [],
  filters: [],
  errorAudience: ""
};

const getters = {
  getFilters(state) {
    return state.filters;
  },
  keys(state) {
    return state.keys;
  },
};

const actions = {
  getAllFilters({ commit }, params = "") {
    return new Promise((resolve, reject) => {
      Segments.get(params).then((response) => {
        resolve(response);
        commit("ADD_AUDIENCE", response.data.data);
        commit("ADD_FILTERS", response.data.data);
      })
        .catch((error) => {
          reject(error);
          if (error.response && router.history.current.name != "Send") {
            commit("DETECT_ERROR", error.response);
          }
        })
    })
  },
  addDefaultFilter({ commit }, filter) {
    commit("ADD_DEFAULT_FILTER", filter);
  },
  addNewFilter({ commit }, filter) {
    commit("ADD_NEW_FILTER", filter)
  }, 
  addNewFilters({ commit }, filter) {
    commit("ADD_FILTERS", filter);
  },
  removeFilter({ commit }, ...args) {
    commit("REMOVE_FILTER", args)
  },
  storeFilter({ commit }, json) {
    commit("STORE_FILTER", json);
  },
  updateFilters({ commit }, aud_id) {
    commit("UPDATE_FILTERS", aud_id)
  },
  updateObjectKey({ commit }, obj) {
    commit("UPDATE_OBJECT_KEY", obj);
  },
  emptyData({ commit }, variable) {
    commit("EMPTY_DATA", variable);
  }
};

const mutations = {
  ADD_FILTERS(state, filters) {
    state.filters = filters;
  },
  ADD_AUDIENCE(state, filters) {
    state.audienceRecords = filters;
  },
  UPDATE_OBJECT_KEY(state, obj) {
    objKey = "";

    state.keys[obj.key] = obj.selected_id;

    if (obj.parent_id === 0 || obj.parent_id) {
      state.filters[0].query.filters[obj.parent_id][obj.prev_parent_key]["filters"][obj.key][obj.selected_id] = state.filters[0].query.filters[obj.parent_id][obj.prev_parent_key]["filters"][obj.key][obj.child_key]
      delete state.filters[0].query.filters[obj.parent_id][obj.prev_parent_key]["filters"][obj.key][obj.child_key]
      objKey = obj.selected_id
    } else {
      state.filters[0].query.filters[obj.key][obj.selected_id] = state.filters[0].query.filters[obj.key][obj.prev_key]
      delete state.filters[0].query.filters[obj.key][obj.prev_key]
      objKey = obj.selected_id
    }
  },
  ADD_DEFAULT_FILTER(state, obj) {
    objKey = "";

    state.filters.push({
      domain_id: obj.domain_id,
      name: obj.name,
      type: "audience",
      query: {
        filters: [
          {
            [objKey]: {
              filters: [],
              type: "and",
              operator: "=",
              buildtype: "",
              values: [],
            },
          }
        ],
      },
    })
  },
  ADD_NEW_FILTER(state, obj) {
    if (obj.obj_direction) {
      state.filters[0].query.filters[obj.key][obj.obj_direction].filters.push({
        [obj.obj_key]: {
          filters: [],
          type: obj.type,
          operator: "=",
          buildtype: "",
          values: [],
        }
      })
    } else {
      state.filters[0].query.filters.push({
        [obj.obj_key]: {
          filters: [],
          type: obj.type,
          operator: "=",
          buildtype: "",
          values: [],
        }
      })
    }
  },
  STORE_FILTER(state, json) {
    Segments.store(json)
      .then((response) => {
      })
      .catch((err) => {
        if (err.response) {
          commit("DETECT_ERROR", err.response);
        }
      })
  },
  UPDATE_FILTERS(state, audId) {
    Segments.update(audId, state.filters[0])
      .then((response) => {
      })
      .catch((err) => {
        if (err.response) {
          commit("DETECT_ERROR", err.response);
        }
      })
  },
  REMOVE_FILTER(state, ...args) {
    if (args[0][0].length > 1) {
      state.filters[0].query.filters[args[0][0][1]][args[0][0][0]]["filters"].splice(args[0][0][2], 1)
    } else {
      state.filters[0].query.filters.splice(args[0][0], 1)
    }
  },
  EMPTY_DATA(state, variable) {
    state[variable] = []
  },
  // Detect Error
  DETECT_ERROR(state, error) {
    if (error.status == 401 || error.status == 419) {
      User.logout().then(() => {
        localStorage.removeItem("auth");
        //localStorage.removeItem("login");
        router.push({ name: "Login", path: router.currentRoute.path });
      })
    } else if (error.data.message !== undefined) {
      state.errorAudience = error.data.message;
    }

    setTimeout(() => {
      state.errorAudience = "";
    }, 1000)
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};